// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style-module__monitoringSummaryWrapper___Zo-3L {\n  height: 160px;\n  width: 270px;\n}\n", "",{"version":3,"sources":["webpack://./app/components/Next/Monitoring/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd","sourcesContent":[".monitoringSummaryWrapper {\n  height: 160px;\n  width: 270px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"monitoringSummaryWrapper": "style-module__monitoringSummaryWrapper___Zo-3L"
};
export default ___CSS_LOADER_EXPORT___;
